import React, { useEffect, useState } from 'react';

let currentSpeech = null;

export default function useTextToSpeech(initVoice = 0) {
  const [voices, setVoices] = useState();
  const [selectedVoice, setSelectedVoice] = useState(initVoice);
  // const [currentSpeech, setCurrentSpeech] = useState(null);

  useEffect(() => {
    window.speechSynthesis.cancel();
    const fetchVoices = () => {
      const voicesList = window.speechSynthesis.getVoices();
      setVoices(voicesList);
    };

    // Fetch voices initially
    fetchVoices();

    // Fetch voices when they change (e.g., on different devices)
    window.speechSynthesis.onvoiceschanged = fetchVoices;
  }, []);

  const isSpeaking = () => {
    return window.speechSynthesis.speaking;
  };

  const isPending = () => {
    return window.speechSynthesis.pending;
  };

  const speak = async (text) => {
    // Detect autoplay/muted condition
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    let allowed = true;

    if (audioCtx.state === 'suspended') {
      try {
        await audioCtx.resume();
      } catch {
        allowed = false;
      }
    }

    // If muted/restricted, skip speech gracefully
    if (!allowed) {
      console.warn('Speech synthesis skipped: tab is muted or audio blocked.');
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);

    utterance.addEventListener('error', (e) => {
      console.warn('Speech synthesis error (likely muted):', e);
    });

    if (voices[selectedVoice]) {
      utterance.voice = voices[selectedVoice];
    }

    utterance.onstart = () => {
      currentSpeech = utterance;
    };

    window.speechSynthesis.speak(utterance);
  };

  const beginNewQueue = (newQueue, repeat, interrupt) => {
    if (newQueue.length === 0) return;
    if (interrupt || (!window.speechSynthesis.speaking && !window.speechSynthesis.pending)) {
      window.speechSynthesis.cancel();

      //add buffer because it's being dumb
      newQueue = ['', ...newQueue];

      newQueue.forEach((item, index) => {
        if (repeat && index === newQueue.length - 1) {
          const value = new SpeechSynthesisUtterance(item.text);
          if (voices[selectedVoice]) value.voice = voices[selectedVoice];

          //set the current value to itself
          value.onstart = () => {
            // setCurrentSpeech(value);
            currentSpeech = value;
          };

          value.onend = () => {
            let sliced = newQueue.slice(1);
            // only repeat if the item should repeat
            sliced = sliced.filter((item) => item.repeat);
            if (sliced.length > 1) beginNewQueue(sliced, repeat, interrupt);
          };
          window.speechSynthesis.speak(value);
        } else {
          speak(item.text);
        }
      });
    } else {
      currentSpeech.onend = () => {
        window.speechSynthesis.cancel();

        //add buffer because it's being dumb
        newQueue = ['', ...newQueue];

        newQueue.forEach((item, index) => {
          if (repeat && index === newQueue.length - 1) {
            const value = new SpeechSynthesisUtterance(item.text);
            if (voices[selectedVoice]) value.voice = voices[selectedVoice];

            //set the current value to itself
            value.onstart = () => {
              // setCurrentSpeech(value);
              currentSpeech = value;
            };

            value.onend = () => {
              let sliced = newQueue.slice(1);
              // only repeat if the item should repeat
              sliced = sliced.filter((item) => item.repeat);
              if (sliced.length > 1) beginNewQueue(sliced, repeat, interrupt);
            };
            window.speechSynthesis.speak(value);
          } else {
            speak(item.text);
          }
        });
      };
    }
  };

  return {
    voices: voices,
    isSpeaking: () => isSpeaking(),
    isPending: () => isPending(),
    setSelectedVoice: (index) => setSelectedVoice(index),
    cancel: () => window.speechSynthesis.cancel(),
    beginNewQueue: (text, repeat = false, interrupt = false) =>
      beginNewQueue(text, repeat, interrupt),
    speak: (text) => speak(text),
  };
}
